import axios from '@/api/requests/axios'

export default {
  getAll: params => axios.get('/api/admin/v1/gift-rules', { params }),
  getById: id => axios.get(`/api/admin/v1/gift-rules/${id}`),

  getOptions: () => axios.get('/api/admin/v1/gift-rules/options'),
  create: rule => axios.post('/api/admin/v1/gift-rules', rule),
  update: rule => axios.put('/api/admin/v1/gift-rules', rule),
  delete: id => axios.delete(`/api/admin/v1/gift-rules/${id}`),
}
